import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB6Skzjjp9TyrNJGT5hjWrHOSyeUzWl6iA',
    libraries: "visualization",
  },
  installComponents: true
})
